import actionTypes from 'constants/actionTypes'

interface ObjectDetailsState {
  isOpen: boolean
}

interface ObjectDetailsAction {
  type: string
}

const initialState: ObjectDetailsState = {
  isOpen: false,
}

const objectDetails = (state: ObjectDetailsState = initialState, action: ObjectDetailsAction): ObjectDetailsState => {
  switch (action.type) {
    case actionTypes.GRAPH.OBJECT_DETAILS.OPEN:
      return {
        isOpen: true
      }
    case actionTypes.GRAPH.OBJECT_DETAILS.CLOSE:
      return {
        isOpen: false
      }
    default:
      return state
  }
}

export default objectDetails
